export default {
  "/financeService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/reviewService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/inceptionService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/craftService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/adPreviewSvc": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/launcherStrategySvcV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/changeHistoryService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/adwordsAccessorService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/campaignLauncher": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/changeLogDbService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/changeLogDbServiceV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/clientInputService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/configurationDbService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/creativeUploadService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/geoTargetingService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/goalValidatorServiceV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/hadesV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/intercom_events": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/intercomEvents": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/irisExecService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/kibanaUI": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/marketingCampaignsDbSvc": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/marketingCampaignServiceV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/ninkasiService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/notificationsServiceV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/notificationsService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/onboardingService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/osBulkActionsService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/osBillingServiceV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/osBillingService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/propertySettingsSvcV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/reportingUISvc/mediaLibrary": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/reportingSvc": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/merchandiseFeedService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/nexusService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/reportingUISvc": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/shopsUIService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/sokratiLiveService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/stripeAccessorService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/suggestionDbSvc": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/tagsRetrofittingSvc": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/ttyaService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/uploaderSvc": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/watchlistService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/osAdsService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/sokratiShopsService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/onBoardingSvcV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/merchandiseDbSvc": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/osGravitiService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/marketplaceService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/marketplace": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/leadManagementService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/neonService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/videoXService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/eventManagerServiceV2": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/brandAdsUIService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/commentsService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/adCardService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/starkService": {
    target: "https://osx-test.onlinesales.ai",
  },
  "/keywordTargetingService": {
    target: "https://osx-test.onlinesales.ai",
  },
};
